<!--供应商帐龄设置-->
<template>
  <el-dialog title="配置帐龄" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form ref="form1">
          <el-row :gutter="20">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                prop="name"
                label="分组编码"
                align="left" width="100"
                header-align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.bm" auto-complete="off" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="摘要"
                align="left" width="200"
                header-align="center">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.name" auto-complete="off" size="mini"></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="code"
                label="适用品牌"
                align="left"
                header-align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.code" multiple placeholder="不选默认全部" size="mini" style="width: 80%">
                    <el-option
                      v-for="item in pingpai"
                      :key="item.CategoryCode"
                      :label="item.CategoryName"
                      :value="item.CategoryCode">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="type"
                label="商品类别"
                align="left" width="200"
                header-align="center">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.type" multiple placeholder="不选默认全部" size="mini">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                prop="age"
                label="帐龄"
                align="left"
                header-align="center" width="100">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.age" :min="1" width="70" :max="10" size="mini" controls-position="right"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <a size="mini" href="javascript:void(0)" style="color:#20A0FF;"
                     type="danger"
                     @click="handleDelete(scope.$index, scope.row,0)">删除
                  </a>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" v-if="CanEdit">完 成</el-button>
      <el-button type="success" plain @click="addNull" v-if="CanEdit">增加一行</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {getPingPaiByServer} from '@/api/set/goodsprice';

  export default {
    name: "AgeEdit",
    data() {
      return {
        dialogFormVisible: false,
        tableData: [],
        formLabelWidth: '120px',
        userInfoModel: {},//缓存数据
        tokenModel: {},
        cusSerial: '',
        CanEdit: false,
        options:[{label:'定制',value:'dz'},{label:'现片',value:'xp'},{label:'加工',value:'jg'},{label:'其他',value:'qt'}],
        pingpai:[],
        selectRow:{},
      }
    },
    props: {
    },
    methods: {
      //删除明细
      handleDelete(index, row, isSkim) {
        this.tableData.splice(index, 1)
      },
      //保存
      saveData(serial) {
        var bms=';';
        for(let i in this.tableData){
          if(!this.tableData[i].bm){
            this.$message({
              message: '编码必须填！',
              type: 'error'
            })
            return;
          }
          if(bms.indexOf(';'+this.tableData[i].bm+';')>-1){
            this.$message({
              message: '编码不能重复！',
              type: 'error'
            })
            return;
          }
          bms+=this.tableData[i].bm+';';

          if(!this.tableData[i].name){
            this.$message({
              message: '名称必须填！',
              type: 'error'
            })
            return;
          }
        }
        this.dialogFormVisible = false
        this.$emit('AfterAgeEdit', JSON.stringify(this.tableData));
      },
      addNull() {
        this.tableData.push({name: '', type: '', code: '', age: 1});
      },
      //绑定查看数据
      initData(customerserial,aging,CanEdit) {
        this.CanEdit = CanEdit;

        this.initForm()
        this.pingpai=[]
        //this.addNull();
        if (customerserial) {
          getPingPaiByServer({customerserial: customerserial}).then(response => {
            this.pingpai = response.data.obj
          });
        }
        if (aging) {
          this.tableData = JSON.parse(aging)
        }
        this.dialogFormVisible = true
      },
      //初始化
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
        }
        this.tableData = []
      },
    },
    mounted() {
      this.tokenModel = JSON.parse(localStorage.getItem("hpapi_tokenModel"))
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      this.financeright = this.$checkRight('财务')
    },
    components: {
    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 40px;
    line-height: 40px;
    padding: 2px;
  }

  .query-table td.content {
    text-align: center;
  }

  .query-table td.mainlink {
    font-weight: bold;
  }

  .titlecolor {
    color: #20A0FF;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/set/externaldept/AgeEdit.vue